import React from 'react';
import { Container, Header, Transition } from 'semantic-ui-react';

import FormularioCrearCompromiso from './FormularioNuevoComentario';
import TarjetaCompromisoDePago from './TarjetaCompromisoDePago';
import TarjetaObservacion from './TarjetaObservacion';
import TarjetaRetiro from './TarjetaRetiro';
import { mapaDeTitulos, TipoCompromiso, TipoNuevoCompromiso, TiposDeObservacionId } from './tipos';

interface Props {
    readonly compromisos: ReadonlyArray<TipoCompromiso>;
    alRegistrarCompromiso(compromiso: TipoNuevoCompromiso): Promise<void>;
    alEliminarCompromiso(compromiso: TipoCompromiso): void;
}

const Compromisos: React.FunctionComponent<Props> = props => {
    const { compromisos, alRegistrarCompromiso, alEliminarCompromiso } = props;
    return (
        <Container text>
            <FormularioCrearCompromiso alRegistrarCompromiso={alRegistrarCompromiso} />

            <Header as='h3'>
                {compromisos.length ? 'Compromisos registrados' : 'No hay compromisos registrados'}
            </Header>

            <Transition.Group animation='fade up' duration={300}>
                {compromisos.map((compromiso, i) => {
                    const Componente = elegirComponenteParaElComentario(compromiso);
                    const titulo =
                        compromiso.tipo === 'otro' ? 'Observación' : mapaDeTitulos[compromiso.tipo];
                    return (
                        <Componente
                            key={`${compromiso.fechaDeRegistro}${i}`}
                            titulo={titulo}
                            alEliminar={() => alEliminarCompromiso(compromiso)}
                            {...compromiso}
                        />
                    );
                })}
            </Transition.Group>
        </Container>
    );
};

function elegirComponenteParaElComentario(compromiso: {
    tipo: TiposDeObservacionId;
    // tslint:disable-next-line:no-any
}): React.ComponentType<any> {
    if (compromiso.tipo === 'compromiso') return TarjetaCompromisoDePago;
    if (compromiso.tipo === 'retiro') return TarjetaRetiro;
    return TarjetaObservacion;
}

export default Compromisos;
export * from './tipos';



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Compromisos/index.tsx